import { QueryClient } from '@tanstack/react-query';
/** The query client every web app runs on, so their defaults can't drift apart. */
export function createWebQueryClient() {
    return new QueryClient({
        defaultOptions: {
            queries: {
                retry: false,
                refetchOnWindowFocus: false,
            },
        },
    });
}
